export type NavLinkItem = {
	to: string;
	label: string;
	end?: boolean;
};

export const navLinks: NavLinkItem[] = [
	{ to: "/home", label: "Home", end: true },
	{ to: "/bill-splitter", label: "Bill Splitter" },
	{ to: "/number-to-word", label: "Number to Words" },
	{ to: "/movie", label: "Movies" },
];
